module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAARVJREFUOBGlkj1rwlAUhk0RhQx1cBAXnXTs2FVcpGtLN1cXx4I4aOlSWtwU/S/+qHxCtkBIfG7xQBLvxWgvHM5HzvNyzr2p1f55XNcd3S0RBMETAkfHcTLrVpUwDPtJknzDTbMse1B8ZZEoitpxHH8CzuGaCpZzVQTIZuwPy7KWxI8C5r1RBKDued6M5i/ibh4qx1oR3/ff0zT9AR6WAV1eEGHsMU0b4Gdds6n2d7vykb1bxB3Jq/rCJApiCpt1VqyzIC28gkn0QkQa+YkGxHvsRWombxQRgBd6Zbod1pNa2V8VUcB5xTV+gTXuEhGI1xsiciCfSE35SpPkARWz4htiW8y4YpnR5gjYXP4v08XahluKasUTUoeGLPJxm+8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sanjiao.png
// module id = 603
// module chunks = 2